import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { NegativePressureWoundTherapyInstruction, PressureMode } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface NegativePressureWoundTherapyInstructionFormGroup {
	pressureSetting: FormControl<UnitQuantity | null>;
	pressureMode: FormControl<PressureMode | null>;
}

@Component({
    selector: 'app-negative-pressure-wound-therapy-item-form',
    templateUrl: './negative-pressure-wound-therapy-item-form.component.html',
    styleUrl: './negative-pressure-wound-therapy-item-form.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, UnitQuantityControl, SelectControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NegativePressureWoundTherapyItemFormComponent implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
  	@Input() itemConfig!: ItemTypeMetadata;

	  pressureModes: SelectItem[] = [
		{ text: 'Continuous', value: PressureMode.Continuous },
		{ text: 'Intermittent', value: PressureMode.Intermittent }
	];

	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<NegativePressureWoundTherapyInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const negativePressureWoundTherapyInstruction = instruction as NegativePressureWoundTherapyInstruction;
			group.addControl('pressureSetting', this.formBuilder.control(negativePressureWoundTherapyInstruction.pressureSetting ?? null));
			group.addControl('pressureMode', this.formBuilder.control(negativePressureWoundTherapyInstruction.pressureMode ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<NegativePressureWoundTherapyInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('pressureSetting', this.formBuilder.control(null));
		group.addControl('pressureMode', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}